export const RoomTypes = {
    LivingRoom: 'LIVING_ROOM',
    Bathroom: 'BATHROOM',
    Kitchen: 'KITCHEN',
    Bedroom: 'BEDROOM',
    DiningRoom: 'DINING_ROOM',
    None: 'NONE',
};

export const RoomTypeLabels = {
    [RoomTypes.LivingRoom]: 'Living Room',
    [RoomTypes.Bathroom]: 'Bathroom',
    [RoomTypes.Kitchen]: 'Kitchen',
    [RoomTypes.Bedroom]: 'Bedroom',
    [RoomTypes.DiningRoom]: 'Dining Room',
    [RoomTypes.None]: 'No Room Assigned',
};
